/*
<summary>
   This file is used to provide initial values or state to the Process Module Observables.
   Developer:Urvashi, Created Date: 23-December-2024
</summary>
*/
import { IPortalListVM } from '../../models/response/IAimsResponse';

const initialPortalState: IPortalListVM = {
  PagingDetails: {
    TotalRecords: 1,
    TotalPages: 1,
    CurrentPage: 1,
    PageSize: 10,
  },
  AIMSs: [],
  AIMSDetails: {
    DeadlineCrossTemplateId: '-1',
    NearDeadLineDate: 0,
    NearDeadlineTemplateId: '-1',
    PatternForMissingPartTemplateId: '-1',
    RegularModeTemplateId: '-1',
    StationCode: '',
    Url: '',
    TenantId: -1,
  },
};

export default initialPortalState;
